export const ROUTES = {
  LOGIN: "/",
  USERS: "/users",
  REPORTS: "/reports",
  EDUCATION_TYPE: "/education-type",
  EMPLOYER: "/employer",
  EXPERIENCE_TITLE: "/experience-title",
  INSTITUTION: "/institution",
  QUALIFICATION: "/qualification",
  TEMPLATES: "/templates",
  CONTACT_REQUESTS: "/contact-requests",
  SUMMARY: "/summary",
  SENIOR_MANAGERIAL_VALUES: "/senior-managerial-values",
  RESPONSIBILITY: "/responsibility",
  SIGNIFICANT_ACHIEVEMENTS: "/significant-achievements",
  COVER_LETTERS: "/cover-letters",
  PLAN_PRICING: "/plan-pricing",
  FLAGGED_PAYMENTS: "/flagged-payments",
  AFFILIATES: "/affiliates",
  AFFILIATE_REPORTS: "/affiliate-reports",
};
